module.exports = __webpack_public_path__ + "static/media/refraction.12b28a93.png";